import { render, staticRenderFns } from "./WorkerAdoptionStatus.vue?vue&type=template&id=19ac175d&"
import script from "./WorkerAdoptionStatus.vue?vue&type=script&lang=js&"
export * from "./WorkerAdoptionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports